$(function () {
	$('.select__active').on('click', function () {
		$(this).parent('.select').children('.select__list').fadeToggle();
		$(this).next('.select__arrow').toggleClass('js-top');
	});

	$('.link select__link').on('click', function () {
		console.log('stl');
	});
});
